<template>
	<div class="index">
		<div class="header1">
			<div class="search" style="height:5vh">
				<span class="iconfont icon-xiazai5" @click="submit"></span>
				<form @submit.prevent="submit">
					<input type="text" placeholder="搜索通讯录" v-model="search" placeholder-class="placeholder"
						style="width: 100%;" @keyup.native.enter='submit' @input="val" />
				</form>
			</div>
			<div class='moreAll'>
				<!-- <span>全部</span> -->
				<!-- <span v-for="(item,index) in people" :key="index" @click="clickcolumnClass(item.level,item.id)" class="little"
					:style="item.shop==1?'color:#02ac54;':'color:#000;'">{{item.level}}</span> -->

			</div>

			<div class='content'>
				<div v-for="(item,index) in list" :key="index">
					<div class='eng'>
						{{item.idx}}
					</div>

					<router-link :to="{
							path: '/detail',
							query: {
							 name: i.name,
							 con: i.id,
							},
							}" class="namelist" v-for="(i,idx) in item.cities" :key="idx">
						<div>
							<div>
								<span class="names">
									{{i.name}}
								</span>
							</div>
							<div class='company'>
								{{i.level.split(',')[0]}}
							</div>
						</div>

						<div @click.stop='telphone'>
							<a :href="'tel:'+i.phone">
								<img src="../../assets/images/telss.png" alt=""
									style="width: 20px;height: 20px;margin-right: 10px;">
							</a>
						</div>
					</router-link>


				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		wx_getLocation,
		ready
	} from "@libs/wechat";
	import {
		trim
	} from "@utils";
	import Clipboard from 'clipboard';
	import {
		getMailList
	} from '../../api/user'
	import {
		isWeixin
	} from "@utils/index";
	import {
		goShopDetail,
	} from "@libs/order";
	import {
		Popup
	} from "vant";
	// import {
	// 	getLevelZhiwei
	// } from '../../api/store'
	let vm = null;
	export default {
		name: "Index",
		components: {
			Popup,
		},
		props: {},
		data: function() {
			return {
				focus: false,
				search: "",
				list: [],
				location: '',
				people: [],
				level: ''
			};
		},

		mounted() {
			this.toSearch()
			this.setOpenShare(); 
			
			// this.getLevelZhiwei()
			document.title = '通讯录';
			var that = this;
		},
		methods: {
			setOpenShare: function() {
				let that = this;
				
				var configAppMessage = {
					desc: '',
					title: '山西数据流量生态园',
					// title:'山西北仑巨邦创新科技有限公司',
					link: location.href,
					imgUrl: window.location.origin+ '/log1.png'
				};
				var configTimeline = {
					title: '山西数据流量生态园',
					// title:'山西北仑巨邦创新科技有限公司',
					link: location.href,
					imgUrl: window.location.origin+ '/log1.png'
				};
				if (isWeixin() === true) {
					ready().then(() => {
						 //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
						          wx.updateAppMessageShareData(configAppMessage);
						          //自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
						          wx.updateTimelineShareData(configTimeline);
					});
			
				}
			},
			goMenus(con, name) {
				this.$router.push({
					path: '/detail',
					query: {
						name: name,
						con: JSON.stringify(con)
					}
				});
			},
			telphone(e) {
				console.log(e.target.dataset.tel)
			},
			clickcolumnClass(e,id) {
				this.level = e
				this.people.forEach(item => {
					item.shop = 0
					if (item.id == id) {
						item.shop = 1
					}
				})
				this.toSearch();
			},
			val(e) {
				if (e.target.value.length == 0) {
					this.toSearch();
				}
			},
			//等级
			async getLevelZhiwei() {
				const res = await getLevelZhiwei()
				var data = [{
					create_date: "2022-06-27 15:54:32",
					del_flag: 0,
					id: '',
					level: "全部",
					isYes: true,
					shop: 1
				}];
				data = data.concat(res.data)
				this.people = data
			},
			submit() {
				const search = trim(this.search) || "";
				this.toSearch(search);
			},
			toSearch(s) {

				const data = {
					level: '',
					search: s
				}
				getMailList(data).then(res => {
					// console.log(res.data.city_nav)
					// res.data.city_nav.forEach(item=>{
					// 	item.cities.forEach(item2=>{
					// 		this.people.forEach(item1=>{
					// 			if(item2.level==item1.id){
					// 				item2.level=item1.level
					// 			}
					// 		})
					// 	})
						
					// })
					// this.$nextTick(() => {
						this.list = res.data.city_nav
						
					// })
					
				}).catch(e => {

				})
			},
			
		}
	};
</script>
<style scoped>
	#launch-btn {
		display: block;
		width: 100%;
		height: 3.5rem;
	}

	.index {
		background-color: #fff;
		/* height: 100vh; */
	}


	.logo {
		width: 60px;
		height: 22px;
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translateY(-50%);
	}

	.logo image {
		width: 100%;
		height: 100%;
		display: block;
	}

	.search {
		width: 90%;
		margin: 10px auto 0;
		height: 31px;
		background-color: #f7f7f7;
		display: flex;
		align-items: center;
		padding: 0 14px;
		box-sizing: border-box;
		font-size: 14px;
		color: #bbb;

	}

	.search .icon-xiazai5 {
		font-size: 15px;
		padding-right: 11px;
		color: #999999;
	}

	.placeholder {
		color: #999999;
		font-size: 14px;
	}

	.moreAll {
		width: 94%;
		margin: 10px auto;
		white-space: nowrap;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}

	.little {
		display: line-block;
		/* background-color: yellow; */
		white-space: nowrap;
		padding: 0 8px;
	}

	.content {
		overflow-y: auto;
		height: 88vh;
		width: 100%;
	}

	.active {
		color: green;
	}

	.eng {
		background-color: #eee;
		padding: 5px 20px;
	}

	.namelist {
		margin: 10px 20px 0;
		border-bottom: 1px solid #eee;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.namelist:last-child {
		border-bottom: none;
	}

	.names {
		color: #000;
		font-size: 15px;
	}

	.zhiwei {
		color: #bbb;
		font-size: 12px;
		margin-left: 20px;
	}

	.company {
		color: #727272;
		font-size: 13px;
		margin-top: 10px;
		padding-bottom: 10px;
	}
</style>
